import * as attendanceSlice from '../../features/attendance/attendance.slice';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Box, Button, Card, Container, Typography } from "@mui/material";
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getMemberByQrToken } from '../../service/qr.service';
import { Member } from '../../service/model/member.model';
import { getMembershipStatusChip } from '../../shared/utils';
import MemberPaymentForm from '../../features/member-payments/components/member-payment-form';
import { MemberPayment, MemberPaymentRequest } from '../../service/model/member-payment.model';
import { createMemberPayment } from '../../features/member-payments/member-payment.slice';
import { AttendanceRequest } from '../../service/model/attendance.model';
import dayjs from 'dayjs';
import { selectLoggedInUser } from '../../features/auth/auth.slice';
import { AttendanceIcon, PriceCheckIcon } from '../../shared/icons';

const AttendanceQRForm = () => {
    const dispatch = useAppDispatch();
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const [member, setMember] = useState<Member | null>(null);
    const [showPaymentForm, setShowPaymentForm] = useState<boolean>(false);

    const { qrToken } = useParams<{ qrToken: string }>();

    useEffect(() => {
        const fetchData = async () => {
            if (qrToken && member === null) {
                const memberData = await getMemberByQrToken(qrToken);
                setMember(memberData);
            }
        };

        fetchData();
    }, []);

    const markAttendance = async () => {
        const sendAttendanceRequest = async () => {
            if(member) {
                const request: AttendanceRequest = {
                    memberId: member.id,
                    checkIn: dayjs(new Date().toISOString()).format("YYYY-MM-DDTHH:mm"),
                    markedByType: 'STAFF',
                    markedByUserId: loggedInUser?.user.id
                }
                await dispatch(attendanceSlice.createAttendance(request));
            }
        }

        await sendAttendanceRequest();
    }

    const handlePaymentSubmit = (data: MemberPaymentRequest) => {
        dispatch(createMemberPayment(data)).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowPaymentForm(false);
            }
        });
    };

    const receivePayment = async () => {
        setShowPaymentForm(true);
    }

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Quick Actions
                </Typography>
                <Card sx={{ mt: 3, width: '100%' }}>
                    <Box sx={{ p: 2 }}>
                        <Typography variant="h6">Member Information</Typography>
                        {member ? (
                            <>
                                <Typography variant="body1" sx={{ mb: 1 }}>{`${member.firstName} ${member.lastName}`}</Typography>
                                {getMembershipStatusChip(member.membershipStatus)}
                            </>
                        ) : (
                            <Typography variant="body1">No member found</Typography>
                        )}
                    </Box>
                </Card>
                {member && (
                    <Box sx={{ mt: 1 }}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            onClick={markAttendance}
                        >
                            <AttendanceIcon sx={{ mr: 1 }} /> Mark Attendance
                        </Button>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            onClick={receivePayment}
                        >
                            <PriceCheckIcon sx={{ mr: 1 }} /> Receive Payment
                        </Button>
                    </Box>
                )}
            </Box>
            {showPaymentForm && member &&
                <MemberPaymentForm payment={{ memberId: member.id, firstName: member.firstName, lastName: member.lastName } as MemberPayment} editable={true} onClose={() => setShowPaymentForm(false)} onSubmit={handlePaymentSubmit} />
            }
        </Container>
    );
}

export default AttendanceQRForm;